export function makeBookmarkPost({ link, title, excerpt, imageSrc, imageAlt }) {
  const safeLink = String(link || "");
  const safeTitle = String(title || "").trim() || safeLink || "Saved post";
  const safeAlt = String(imageAlt || "").trim() || safeTitle;
  const safeExcerpt = String(excerpt || "").trim();
  const safeImageSrc = String(imageSrc || "").trim();

  const contentImage = safeImageSrc
    ? `<img src="${safeImageSrc}" alt="${safeAlt.replace(/"/g, "&quot;")}" />`
    : "";

  return {
    link: safeLink,
    title: { rendered: safeTitle },
    excerpt: { rendered: safeExcerpt ? `<p>${safeExcerpt}</p>` : "" },
    content: { rendered: contentImage },
  };
}

